const ruleCodeMapping = {
  biggest_lost: '最大遗漏',
  cold: '冷',
  danshuang_dan: '单',
  danshuang_he: '和',
  danshuang_shuang: '双',
  daxiao_da: '大',
  daxiao_he: '和',
  daxiao_xiao: '小',
  mantissa_daxiao_da: '大',
  mantissa_daxiao_he: '和',
  mantissa_daxiao_xiao: '小',
  dongWu_jiaChin: '家禽',
  dongWu_yehShou: '野兽',
  fangSiang_bei: '北',
  fangSiang_dong: '东',
  fangSiang_nan: '南',
  fangSiang_si: '西',
  haiSian_huLu: '葫芦',
  haiSian_ji: '鸡',
  haiSian_jinChian: '金钱',
  haiSian_sia: '虾',
  haiSian_sieh: '蟹',
  haiSian_yu: '鱼',
  he: '和',
  hot: '热',
  jhihHe_he: '合',
  jhihHe_jhih: '质',
  jiZhi_he: '和',
  jiZhi_jiDa: '极大',
  jiZhi_jiXiao: '极小',
  longHu_he: '和',
  longHu_hu: '虎',
  longHu_long: '龙',
  maJiang_bai: '白',
  maJiang_fa: '发',
  maJiang_jhong: '中',
  nanNyu_nan: '男',
  nanNyu_nyu: '女',
  now_lost: '现在遗漏',
  puke_banShun: '半顺',
  puke_baoZih: '豹子',
  puke_dueiZih: '对子',
  puke_shunZih: '顺子',
  puke_zaLiou: '杂六',
  puke_sanBuTong: '三不同',
  shengXiao_gou: '狗',
  shengXiao_hou: '猴',
  shengXiao_hu: '虎',
  shengXiao_jhu: '猪',
  shengXiao_ji: '鸡',
  shengXiao_long: '龙',
  shengXiao_ma: '马',
  shengXiao_niou: '牛',
  shengXiao_she: '蛇',
  shengXiao_shu: '鼠',
  shengXiao_tu: '兔',
  shengXiao_yang: '羊',
  sihJi_chiou: '秋',
  sihJi_chun: '春',
  sihJi_dong: '冬',
  sihJi_sia: '夏',
  sihYi_chi: '棋',
  sihYi_chin: '琴',
  sihYi_hua: '画',
  sihYi_shu: '书',
  tianDi_di: '地',
  tianDi_tian: '天',
  warm: '温',
  wuXing_huo: '火',
  wuXing_jin: '金',
  wuXing_mu: '木',
  wuXing_shuei: '水',
  wuXing_tu: '土',
  yanse_he: '和',
  yanse_hong: '红',
  yanse_lan: '蓝',
  yanse_lyu: '绿',
  zuSyuan_baoZih: '豹子',
  zuSyuan_zuLiou: '组六',
  zuSyuan_zuSan: '组三'
}

const lotteryNameMapping = {
  // 六合彩系列
  hk6: '香港六合彩',
  ff6: '分分六合彩',
  sf6: '三分六合彩',
  js6: '极速6合彩',
  // 時時彩系列
  ssc: '时时彩',
  jsssc: '极速时时彩',
  wfssc: '五分时时彩',
  cqssc: '重庆时时彩',
  xjssc: '新疆时时彩',
  tjssc: '天津时时彩',
  // pk10系列
  pk10: 'PK拾',
  jspk10: '极速PK拾',
  bjpk10: '北京PK拾',
  wfpk10: '五分PK拾',
  malxyft: '幸运飞艇',
  // 幸運28系列
  xy28: '幸运28',
  bjxy28: '北京幸运28',
  xjpxy28: '新加坡幸运28',
  jndbsxy28: '加拿大幸运28',
  twxy28: '台湾幸运28',
  wfxy28: '五分幸运28',
  // 11選5系列
  '11x5': '11选5',
  gd11x5: '广东11选5',
  sd11x5: '山东11选5',
  jx11x5: '江西11选5',
  sh11x5: '上海11选5',
  ah11x5: '安徽11选5',
  bj11x5: '北京11选5',
  fj11x5: '福建11选5',
  gs11x5: '甘肃11选5',
  gx11x5: '广西11选5',
  gz11x5: '贵州11选5',
  hb11x5: '湖北11选5',
  heb11x5: '河北11选5',
  hlj11x5: '黑龙江11选5',
  jl11x5: '吉林11选5',
  js11x5: '江苏11选5',
  ln11x5: '辽宁11选5',
  nmg11x5: '内蒙古11选5',
  qh11x5: '青海11选5',
  shx11x5: '山西11选5',
  sx11x5: '陕西11选5',
  tj11x5: '天津11选5',
  xj11x5: '新疆11选5',
  yn11x5: '云南11选5',
  zj11x5: '浙江11选5',
  // 快三系列
  k3: '快3',
  jisuk3: '极速快3',
  wfk3: '五分快3',
  ahk3: '安徽快3',
  hbk3: '湖北快3',
  gxk3: '广西快3',
  hebk3: '河北快3',
  shk3: '上海快3',
  jsk3: '江苏快3',
  bjk3: '北京快3',
  fjk3: '福建快3',
  gsk3: '甘肃快3',
  gzk3: '贵州快3',
  hnk3: '河南快3',
  jlk3: '吉林快3',
  jxk3: '江西快3',
  nmgk3: '内蒙古快3',
  // 快樂十分
  cqxync: '重庆幸运农场',
  gdkl10: '广东快乐十分',
  tjkl10: '天津快乐十分',
  // 快樂8
  bjkl8: '北京快乐8',
  jndbskl8: '加拿大卑诗快乐8',
  twbingo: '台湾宾果',
  wfkl8: '五分快乐8',
  xjpkl8: '新加坡快乐8',
  // 其他
  fc3d: '福彩3D',
  shssc: '上海时时乐',
  cjdlt: '超级大乐透',
  fcssq: '福彩双色球',
  pl3: '排列3',
  pl5: '排列5',
  qlc: '七乐彩',
  qxc: '七星彩'
}

const lotteryTypeItems = {
  '11x5': [
    { label: '安徽11选5', lotteryCode: 'ah11x5' },
    { label: '北京11选5', lotteryCode: 'bj11x5' },
    { label: '福建11选5', lotteryCode: 'fj11x5' },
    { label: '广东11选5', lotteryCode: 'gd11x5' },
    { label: '甘肃11选5', lotteryCode: 'gs11x5' },
    { label: '广西11选5', lotteryCode: 'gx11x5' },
    { label: '贵州11选5', lotteryCode: 'gz11x5' },
    { label: '湖北11选5', lotteryCode: 'hb11x5' },
    { label: '河北11选5', lotteryCode: 'heb11x5' },
    { label: '黑龙江11选5', lotteryCode: 'hlj11x5' },
    { label: '吉林11选5', lotteryCode: 'jl11x5' },
    { label: '江苏11选5', lotteryCode: 'js11x5' },
    { label: '江西11选5', lotteryCode: 'jx11x5' },
    { label: '辽宁11选5', lotteryCode: 'ln11x5' },
    { label: '内蒙古11选5', lotteryCode: 'nmg11x5' },
    { label: '青海11选5', lotteryCode: 'qh11x5' },
    { label: '山东11选5', lotteryCode: 'sd11x5' },
    { label: '上海11选5', lotteryCode: 'sh11x5' },
    { label: '山西11选5', lotteryCode: 'shx11x5' },
    { label: '陕西11选5', lotteryCode: 'sx11x5' },
    { label: '天津11选5', lotteryCode: 'tj11x5' },
    { label: '新疆11选5', lotteryCode: 'xj11x5' },
    { label: '云南11选5', lotteryCode: 'yn11x5' },
    { label: '浙江11选5', lotteryCode: 'zj11x5' }
  ],
  k3: [
    { label: '安徽快3', lotteryCode: 'ahk3' },
    { label: '北京快3', lotteryCode: 'bjk3' },
    { label: '福建快3', lotteryCode: 'fjk3' },
    { label: '甘肃快3', lotteryCode: 'gsk3' },
    { label: '广西快3', lotteryCode: 'gxk3' },
    { label: '贵州快3', lotteryCode: 'gzk3' },
    { label: '湖北快3', lotteryCode: 'hbk3' },
    { label: '河北快3', lotteryCode: 'hebk3' },
    { label: '河南快3', lotteryCode: 'hnk3' },
    { label: '极速快3', lotteryCode: 'jisuk3' },
    { label: '吉林快3', lotteryCode: 'jlk3' },
    { label: '江苏快3', lotteryCode: 'jsk3' },
    { label: '江西快3', lotteryCode: 'jxk3' },
    { label: '内蒙古快3', lotteryCode: 'nmgk3' },
    { label: '上海快3', lotteryCode: 'shk3' },
    { label: '五分快3', lotteryCode: 'wfk3' }
  ],
  pk10: [
    { label: '北京PK拾', lotteryCode: 'bjpk10' },
    { label: '极速PK拾', lotteryCode: 'jspk10' },
    { label: '五分PK拾', lotteryCode: 'wfpk10' },
    { label: '幸运飞艇', lotteryCode: 'malxyft' }
  ],
  xy28: [
    { label: '北京幸运28', lotteryCode: 'bjxy28' },
    { label: '加拿大幸运28', lotteryCode: 'jndbsxy28' },
    { label: '台湾幸运28', lotteryCode: 'twxy28' },
    { label: '五分幸运28', lotteryCode: 'wfxy28' }
  ],
  ssc: [
    { label: '重庆时时彩', lotteryCode: 'cqssc' },
    { label: '极速时时彩', lotteryCode: 'jsssc' },
    { label: '上海时时乐', lotteryCode: 'shssc' },
    { label: '天津时时彩', lotteryCode: 'tjssc' },
    { label: '五分时时彩', lotteryCode: 'wfssc' },
    { label: '新疆时时彩', lotteryCode: 'xjssc' }
  ],
  kl10: [
    { label: '广东快乐十分', lotteryCode: 'gdkl10' },
    { label: '天津快乐十分', lotteryCode: 'tjkl10' },
    { label: '重庆幸运农场', lotteryCode: 'cqxync' }
  ],
  kl8: [
    { label: '北京快乐8', lotteryCode: 'bjkl8' },
    { label: '加拿大卑诗快乐8', lotteryCode: 'jndbskl8' },
    { label: '五分快乐8', lotteryCode: 'wfkl8' }
  ],
  hk6: [
    { label: '分分六合彩', lotteryCode: 'ff6' },
    { label: '香港六合彩', lotteryCode: 'hk6' },
    { label: '三分六合彩', lotteryCode: 'sf6' },
    { label: '极速六合彩', lotteryCode: 'js6' }
  ],
  others: [
    { label: '福彩3D', lotteryCode: 'fc3d' },
    { label: '福彩双色球', lotteryCode: 'fcssq' },
    { label: '排列3', lotteryCode: 'pl3' },
    { label: '排列5', lotteryCode: 'pl5' },
    { label: '七乐彩', lotteryCode: 'qlc' },
    { label: '七星彩', lotteryCode: 'qxc' },
    { label: '超级大乐透', lotteryCode: 'cjdlt' },
    { label: '台湾宾果', lotteryCode: 'twbingo' }
  ]
}

const presentLabelOptions = [{
  name: '遗漏',
  val: 'presentMissing'
}, {
  name: '折线',
  val: 'presentLine'
}, {
  name: '遗漏分层',
  val: 'presentLineMissingLayer'
}, {
  name: '分隔线',
  val: 'presentLineDivided'
}]

const countRangeOptions = [{
  name: '近30期',
  val: '30'
}, {
  name: '近60期',
  val: '60'
}, {
  name: '近90期',
  val: '90'
}]

// 殺號計畫
const shjhLink = '/m/shjh'
const shJhLotteryList = [{
  label: 'PK10系列',
  children: lotteryTypeItems['pk10']
    .map((lottery) => Object.assign({}, lottery, { link: `${shjhLink}/${lottery.lotteryCode}` }))
}, {
  label: '时时彩系列',
  children: lotteryTypeItems['ssc']
    .map((lottery) => Object.assign({}, lottery, { link: `${shjhLink}/${lottery.lotteryCode}` }))
}, {
  label: '11选5系列',
  children: lotteryTypeItems['11x5']
    .map((lottery) => Object.assign({}, lottery, { link: `${shjhLink}/${lottery.lotteryCode}` }))
}, {
  label: '快三系列',
  children: lotteryTypeItems['k3']
    .map((lottery) => Object.assign({}, lottery, { link: `${shjhLink}/${lottery.lotteryCode}` }))
}]

// 專家推薦
const expertLink = '/m/expert'
const expertLotteryList = [{
  label: 'PK10系列',
  children: lotteryTypeItems['pk10']
    .map((lottery) => Object.assign({}, lottery, { link: `${expertLink}/${lottery.lotteryCode}` }))
}, {
  label: '时时彩系列',
  children: lotteryTypeItems['ssc']
    .map((lottery) => Object.assign({}, lottery, { link: `${expertLink}/${lottery.lotteryCode}` }))
}]

// 競猜系列
const lotterybetLotterylist = [{
  label: '彩种',
  children: [{
    label: '极速PK10',
    lotteryCode: 'jspk10'
  }, {
    label: '五分PK10',
    lotteryCode: 'wfpk10'
  }, {
    label: '北京PK10',
    lotteryCode: 'bjpk10'
  }, {
    label: '马耳他幸运飞艇',
    lotteryCode: 'malxyft'
  }]
}]

export {
  ruleCodeMapping,
  lotteryNameMapping,
  lotteryTypeItems,
  presentLabelOptions,
  countRangeOptions,

  shJhLotteryList,
  expertLotteryList,
  lotterybetLotterylist
}
